import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="invoices--selected-contact"
export default class extends Controller {
  static classes = ["visible"]
  static targets = ["popup", "contact"]
  static outlets = ["invoices--tax-document-picker"]

  connect() {
    // Store the bound handler so it can be removed
    this._selectedContactListener = this.#selectedContactListener.bind(this)
    document.addEventListener("selectedContact", this._selectedContactListener)
  }

  disconnect() {
    document.removeEventListener("selectedContact", this._selectedContactListener)
  }

  showPopup() {
    this.popupTarget.classList.add("selected-contact__popup--open")
  }

  hidePopup() {
    this.popupTarget.classList.remove("selected-contact__popup--open")
  }

  changeContact() {
    this.#dispatchChangeContactEvent()
    this.contactTarget.classList.remove(this.visibleClass)
  }

  #dispatchChangeContactEvent() {
    const event = new CustomEvent("changeContact")
    document.dispatchEvent(event)
  }

  #isEmptyContact(contact) {
    return contact.text === "" && contact.value === ""
  }

  #selectedContactListener(event) {
    const data = event.detail

    if (this.#isEmptyContact(data)) {
      return
    }
    if (this.hasInvoicesTaxDocumentPickerOutlet) {
      this.invoicesTaxDocumentPickerOutlet.setTaxDocumentsSelectOptions(data.value)
    }
    this.contactTarget.classList.add(this.visibleClass)
  }
}
